namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_form, {

		background: {
			// color: $mol_theme.back,
		},
		
		// Head: {
		// 	padding: $mol_gap.space,
		// },

		// Title: {
		// 	align: {
		// 		items: 'center',
		// 	},
		// },

		Form: {
			padding: $mol_gap.block,
			// background: {
			// 	color: $mol_theme.card,
			// },
		},
		
	} )
	
}
